import { BOOLEAN_AS_STRING, OrderApiData } from "@swiggy-private/payment-types";
import { ApiResponse } from "@payment-client/interfaces/Api";

export const mockPlaceOrderResponse: ApiResponse<OrderApiData> = {
    statusCode: 0,
    data: {
        orderData: {
            orderPaymentMethod: "",
            isSwiggyBlackOtpApplicable: false,
            isSwiggyBlackOtpAnimationEnabled: false,
            isAffordableM2ExperienceEnabledOnOrderConfirmationScreen: true,
            orderTransitionScreenNewMsgEnabled: true,
            successMessageInfo: "You saved [[₹31]] on this order with {{img|v1634558776/swiggy_one/OneLogo_3x.png}}",
            successMessageInfoV2:
                "152 saved <br> On Time Delivery <br> Express Delivery{{img|portal/testing/express_logo.png}}",
            isSwiggyBlackApplicable: true,
            orderId: 123455,
            orderStatus: "processing",
            postStatus: "processing",
            orderType: "regular",
            orderTotal: 100,
            primaryPaymentTransactionAmount: 100,
            orderItems: [{ quantity: 1 }],
            juspayMeta: {
                juspayClientAuthToken: "Xxxx-s-sds",
                juspayClientAuthTokenExpiry: 1000,
            },
            deliveryAddress: {
                id: "236594699",
                version: 8,
                name: "Shriphad Rao",
                addressLine1: "Budhwal, Haryana 123023, India",
                addressLine2: "",
                address: "Budhwal, Haryana 123023, India",
                landmark: "f",
                area: "test",
                mobile: "7989419452",
                alternateMobile: "",
                annotation: "work",
                instructions: "Landmark: f",
                email: "shriphadnike@gmail.com",
                flatNo: "123",
                city: "",
                lat: "27.8374445",
                lng: "76.1725774",
                isVerified: false,
                addressCategory: 2,
            },
            paasId: "123",
            credConfirmationTimeMinutes: "1",
            paymentPartnerOrderId: "123455E1",
            paymentTxnId: "123455E1",
            successMessageType: "SUPER",
            confirmationTimeMinutes: "5",
            rawResponse: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                order_data: {
                    key: "fce9c01a-6fec-4fc6-8c84-1119ccf286c4",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_id: 123455,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_status: "processing",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    post_status: "processing",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    juspay_meta: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        juspay_client_auth_token: "Xxxxxx",
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        juspay_client_auth_token_expiry: 1000,
                    },
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_items: [{ quantity: 1 }],
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_payment_method: "",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_total: 100,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_type: "regular",
                },
                // eslint-disable-next-line @typescript-eslint/naming-convention
                retry_count: 0,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                retry_delay_time_in_ms: 0,
            },
            pendingPaymentParams: {
                method: "POST",
                endpoint: "/api/v1/confirm",
                host: "https://chckout.swiggy.com",
                headers: {},
            },
        },
        retryCount: 0,
        retryDelayTimeInMs: 0,
        xpData: {
            orderTransitionScreenMsg: BOOLEAN_AS_STRING.TRUE,
        },
    },
};

export const mockConfirmOrderResponse: ApiResponse<OrderApiData> = {
    statusCode: 0,
    data: {
        orderData: {
            orderPaymentMethod: "",
            orderId: 123455,
            orderType: "regular",
            orderStatus: "processing",
            postStatus: "success",
            orderTotal: 100,
            orderItems: [{ quantity: 1 }],
            successMessageInfo: "You saved [[₹31]] on this order with {{img|v1634558776/swiggy_one/OneLogo_3x.png}}",
            successMessageInfoV2: "[[₹162]] saved <br/> ON-TIME GUARANTEE <br/> EXPRESS DELIVERY {{logo.jpg}}",
            isSwiggyBlackApplicable: false,
            isSwiggyBlackOtpApplicable: false,
            isSwiggyBlackOtpAnimationEnabled: false,
            isAffordableM2ExperienceEnabledOnOrderConfirmationScreen: true,
            orderTransitionScreenNewMsgEnabled: true,
            juspayMeta: {
                juspayClientAuthToken: "Xxxx-s-sds",
                juspayClientAuthTokenExpiry: 1000,
            },
            paasId: "123",
            paymentPartnerOrderId: "123455E1",
            paymentTxnId: "123455E1",
            successMessageType: "SUPER",
            deliveryAddress: {
                id: "236594699",
                version: 8,
                name: "Shriphad Rao",
                addressLine1: "Budhwal, Haryana 123023, India",
                addressLine2: "",
                address: "Budhwal, Haryana 123023, India",
                landmark: "f",
                area: "test",
                mobile: "7989419452",
                alternateMobile: "",
                annotation: "work",
                instructions: "Landmark: f",
                email: "shriphadnike@gmail.com",
                flatNo: "123",
                city: "",
                lat: "27.8374445",
                lng: "76.1725774",
                isVerified: false,
                addressCategory: 2,
            },
            rawResponse: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                order_data: {
                    key: "fce9c01a-6fec-4fc6-8c84-1119ccf286c4",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_id: 123455,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_status: "processing",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    post_status: "processing",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    juspay_meta: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        juspay_client_auth_token: "Xxxxxx",
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        juspay_client_auth_token_expiry: 1000,
                    },
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_items: [{ quantity: 1 }],
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_payment_method: "",
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_total: 100,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    order_type: "regular",
                },
                // eslint-disable-next-line @typescript-eslint/naming-convention
                retry_count: 0,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                retry_delay_time_in_ms: 0,
            },
            pendingPaymentParams: {
                method: "POST",
                endpoint: "/api/v1/confirm",
                host: "https://chckout.swiggy.com",
                headers: {},
            },
        },
        retryCount: 0,
        retryDelayTimeInMs: 0,
    },
};
